import { AxiosError } from 'axios';
import { createAsyncAction, ActionType, createAction } from 'typesafe-actions';
import { MenuModelState } from '../models/menuModel';

const DISPATH_TOP_MENU = 'menu/DISPATH_TOP_MENU';

export const dispatchTopMenu = createAction(DISPATH_TOP_MENU)<string>();

const actions = {
  dispatchTopMenu
};

export type MenuAction = ActionType<typeof actions>;
